
const m = window.require("discourse/helpers/replace-emoji");
if (m.default && !m.__esModule) {
  m.__esModule = true;
}
module.exports = m;
